var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 78,
    viewBox: "0 0 70 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 27.6924C34.4649 27.6924 34.0323 27.1761 34.0323 26.5386V18.4614C34.0323 17.8239 34.4654 17.3076 35.0001 17.3076C35.5347 17.3076 35.9678 17.8239 35.9678 18.4614V26.5386C35.9678 27.1761 35.5352 27.6924 35.0001 27.6924Z",
    fill: "#DBD9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8989 27.337C21.6087 27.337 21.3222 27.1826 21.1313 26.8873L16.029 18.999C15.7031 18.4941 15.7814 17.7693 16.2048 17.3807C16.6283 16.9899 17.2357 17.0865 17.5621 17.5903L22.6643 25.4792C22.9903 25.984 22.912 26.7083 22.4885 27.0969C22.3128 27.2595 22.1049 27.337 21.8989 27.337Z",
    fill: "#C9C6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6957 27.938C28.3121 27.938 27.9481 27.664 27.7966 27.2121L24.9219 18.6442C24.7232 18.0526 24.9654 17.3807 25.4616 17.1444C25.9532 16.9086 26.5199 17.1941 26.7195 17.7879L29.5943 26.3557C29.7929 26.9474 29.5508 27.6192 29.0546 27.8556C28.9374 27.9118 28.8156 27.938 28.6957 27.938Z",
    fill: "#C9C6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1011 27.3371C47.8951 27.3371 47.6872 27.2596 47.5115 27.097C47.088 26.7083 47.0098 25.9841 47.3357 25.4792L52.4379 17.5903C52.7652 17.0855 53.3718 16.9889 53.7952 17.3808C54.2186 17.7694 54.2969 18.4942 53.971 18.999L48.8687 26.8874C48.6778 27.1832 48.3913 27.3371 48.1011 27.3371Z",
    fill: "#DBD9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3042 27.938C41.1843 27.938 41.0625 27.9118 40.9453 27.8556C40.4491 27.6187 40.207 26.9474 40.4056 26.3558L43.2804 17.7874C43.4791 17.1936 44.0467 16.9076 44.5383 17.1439C45.0345 17.3808 45.2762 18.0521 45.078 18.6437L42.2033 27.2121C42.0518 27.664 41.6883 27.938 41.3042 27.938Z",
    fill: "#DBD9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87097 11.5386V17.3076C8.87097 18.582 9.73752 19.6152 10.8064 19.6152H59.1934C60.2623 19.6152 61.1293 18.582 61.1293 17.3076V11.5386H8.87097Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0323 0H5.96771C5.43304 0 5 0.516319 5 1.1538V11.5386C5 12.813 5.86655 13.8462 6.93542 13.8462H63.0646C64.1335 13.8462 65 12.813 65 11.5386V1.1538C65 0.516319 64.567 0 64.0323 0Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 7.11553C37 8.49604 35.8807 9.61523 34.5 9.61523C33.1193 9.61523 32 8.49604 32 7.11553C32 5.73443 33.1193 4.61523 34.5 4.61523C35.8807 4.61523 37 5.73443 37 7.11553Z",
    fill: "#FF8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5161 6.92337V0H5.96771C5.43304 0 5 0.516865 5 1.1538V11.5386C5 12.813 5.86655 13.8462 6.93542 13.8462H63.0646C64.1335 13.8462 65 12.813 65 11.5386H23.387C21.2492 11.5386 19.5161 9.47222 19.5161 6.92337Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5805 30H22.4191C21.3502 30 20.4836 28.9668 20.4836 27.6924C20.4836 26.4174 21.3502 25.3848 22.4191 25.3848H47.5805C48.6494 25.3848 49.5159 26.4179 49.5159 27.6924C49.5159 28.9668 48.6494 30 47.5805 30Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2681 25.3848H22.4191C21.3502 25.3848 20.4836 26.4174 20.4836 27.6924C20.4836 28.9668 21.3502 30 22.4191 30H47.5805C48.6494 30 49.5159 28.9668 49.5159 27.6924H31.2036C30.1347 27.6924 29.2681 26.6592 29.2681 25.3848Z",
    fill: "#DBD9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8794 38.1107C38.4053 39.7201 44.6532 44.7123 43.1958 54.0194C43.1958 54.0194 44.8238 53.2384 46.2712 51.7931C46.6055 51.4596 47.2765 51.5878 47.3898 52.0062C47.6415 52.9369 47.9463 54.4274 47.9967 56.3126C48.1494 62.0087 42.5643 66.8971 35.479 66.9071C28.6086 66.9169 23.001 62.4003 23.001 56.8546C23.001 52.0492 25.8939 49.5409 27.0079 45.4071C27.0996 45.0665 27.586 44.9034 27.9585 45.0817C28.8038 45.4857 30.1404 46.2425 31.0148 47.318C31.0148 47.318 34.5705 43.6962 34.8489 38.4999C34.8714 38.08 35.4698 37.8495 35.8794 38.1107Z",
    fill: "#FFAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2514 56.8065C41.2537 58.0106 39.9892 58.2843 39.9892 58.2843C40.5011 53.3444 38.1513 49.7194 37.1837 48.4594C37.0468 48.2809 36.7067 48.328 36.6514 48.5331C35.7667 51.8334 33.3911 53.6662 33.3911 53.6662C32.6181 52.9413 31.8833 52.6444 31.5011 52.5297C31.3508 52.4848 31.1902 52.5512 31.1343 52.672C30.1585 54.7763 28.3143 56.4008 27.8947 58.8197C27.2771 62.3791 30.4934 65.7526 34.9521 66.0016C39.4493 66.2528 43.1945 63.3935 43.1945 59.831C43.1945 58.3979 42.9577 57.4135 42.7764 56.8705C42.7111 56.6745 42.3911 56.6378 42.2514 56.8065Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6864 56.258C35.5938 56.0708 35.2978 56.0193 35.129 56.1682C34.1206 57.0586 31.4108 59.6645 31.4108 61.9592C31.4108 63.7756 33.2422 65.2483 35.5015 65.2483C37.7605 65.2483 39.5919 63.7756 39.5919 61.9592C39.5919 60.2322 36.951 58.8161 35.6864 56.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.989 70.0001H31.0137C30.6596 70.0001 30.3724 69.7694 30.3724 69.4847C30.3724 69.1998 30.6596 68.9691 31.0137 68.9691H39.989C40.3431 68.9691 40.63 69.1998 40.63 69.4847C40.63 69.7694 40.3431 70.0001 39.989 70.0001Z",
    fill: "#B67F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0137 70.0001H34.219V68.9691H31.0137C30.6596 68.9691 30.3724 69.1998 30.3724 69.4847C30.3724 69.7694 30.6596 70.0001 31.0137 70.0001Z",
    fill: "#A06E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3714 66.9025C34.0382 66.8222 22.5725 65.1029 26.526 53.5038C28.0013 49.1759 28.2597 45.2316 28.2597 45.2316C28.1543 45.1779 28.052 45.1269 27.9575 45.0817C27.585 44.9035 27.0986 45.0666 27.0069 45.4071C25.8929 49.5407 23 52.0492 23 56.8546C23 62.3712 28.5274 66.8461 35.3714 66.9025Z",
    fill: "#FF8C5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeat);
export default __webpack_public_path__ + "static/media/heat.60ed0346fc08408beb0dbc1cb10ce07c.svg";
export { ForwardRef as ReactComponent };